import { Alert, AlertIcon, Box, Button, forwardRef } from "@chakra-ui/react";
import { ConnectButton, useChainModal } from "@rainbow-me/rainbowkit";
import { useEffect } from "react";
import { useAccount } from "wagmi";
import { useSupportedNetwork } from "../helpers/hooks/network";
import analyticsInstance from "../config/analytics";

const WalletNetwork = forwardRef((props, ref) => {
  const { isConnected, address } = useAccount();
  const { isSupportedNetwork } = useSupportedNetwork();
  const { openChainModal } = useChainModal();

  useEffect(() => {
    if (isConnected && address) analyticsInstance.identify(address);
  }, [isConnected, address]);

  return (
    <>
      {!isConnected && (
        <Box py="2em">
          <Alert status="warning">
            <AlertIcon />
            Connect your wallet to BTFDCA!&nbsp;
            <ConnectButton label="Connect!" />
          </Alert>
        </Box>
      )}

      {isConnected && !isSupportedNetwork && (
        <Box py="2em">
          <Alert status="warning">
            <AlertIcon />
            Please use a supported network.&nbsp;
            <Button colorScheme="blue" size="xs" onClick={openChainModal}>
              Switch network!
            </Button>
          </Alert>
        </Box>
      )}
    </>
  );
});

export default WalletNetwork;
